module.exports = __webpack_public_path__ + "img/instant-pot-spaghetti_4.834a183f.jpg";